import toUnderscored from 'app/common/lib/react/toUnderscored';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import { deepMapStringKeys } from 'app/common/lib/util/ObjectUtils';

export const FIELD_VALIDATION_TIMEOUT = 300;

export const prefixRegisterAction = (prefix) => (suffix) => trackRegisterAction(prefix + suffix);

export const toUnderscoredObject = (obj) => deepMapStringKeys(toUnderscored)(obj);
